import type { ReactElement } from 'react'
import { Toaster as SonnerToaster, type ToasterProps } from 'sonner'

import { useTheme } from '@/components/theme/theme-context'
import { cn } from '@/lib/utils'

/**
 * Toaster do painel. Segue o tema do app e usa as superfícies do tema em vez
 * das cores próprias do sonner — o painel não tem uma segunda paleta.
 */
function Toaster(props: ToasterProps): ReactElement {
  const { tema } = useTheme()

  return (
    <SonnerToaster
      theme={tema}
      position="top-right"
      closeButton
      toastOptions={{
        classNames: {
          toast: cn(
            'rounded-lg border border-border bg-popover text-popover-foreground shadow-overlay',
            'text-sm',
          ),
          description: 'text-fg-secondary',
          actionButton: 'bg-primary text-primary-foreground rounded-md',
          cancelButton: 'bg-elevated text-fg-secondary rounded-md',
          // `-fg`: a borda precisa aparecer sobre o popover BRANCO do tema claro.
          error: 'border-danger-fg/40',
          success: 'border-success-fg/40',
          warning: 'border-warning-fg/40',
          info: 'border-info-fg/40',
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
